import { render, staticRenderFns } from "./IconRdv.vue?vue&type=template&id=59b1a959&"
import script from "./IconRdv.vue?vue&type=script&lang=js&"
export * from "./IconRdv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports